import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ArrowBack } from '@mui/icons-material';
import { Button } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { useAppDispatch } from 'store/store';
import { pushNotification } from 'store/notifications/notifications.slices';
import { NOTIFICATION_TYPES } from 'store/notifications/notifications.types';
import { getOrderFormSchema } from '../OrderForm/OrderForm.schema';
import { getEmptyOrderFormValues } from '../OrderForm/OrderForm.defaults';
import { OrderForm } from '../OrderForm/OrderForm';
import { formValuesToOrderItem } from '../OrderForm/OrderForm.utils';
import { TOrderFormValues } from '../OrderForm/OrderForm.types';
import { TOrderCreate } from './OrderCreate.types';
import '../OrderDetail/OrderDetail.styled.scss';
import '../../../../AdminPanel.styles.scss';

export const OrderCreate: TOrderCreate = ({ onBack }) => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();

  const orderFormSchema = React.useMemo(
    () => getOrderFormSchema(localize),
    [localize]
  );

  const defaultValues = React.useMemo(() => getEmptyOrderFormValues(), []);

  const form = useForm<TOrderFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues,
    resolver: yupResolver(orderFormSchema) as Resolver<TOrderFormValues>,
  });

  const handleSubmit = (data: TOrderFormValues) => {
    // eslint-disable-next-line no-console
    console.log('order create', formValuesToOrderItem(data));
    dispatch(
      pushNotification({
        message: localize('admin.orders.form.saved') as string,
        type: NOTIFICATION_TYPES.SUCCESS,
      })
    );
    onBack();
  };

  return (
    <div className="admin-orders-detail">
      <div className="admin-orders-detail__toolbar">
        <Button
          type="button"
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={onBack}
        >
          {localize('admin.orders.back')}
        </Button>
        <div className="admin-orders-detail__toolbar-center">
          <h2 className="h5 admin-orders-detail__title">
            {localize('admin.orders.form.title.create')}
          </h2>
        </div>
        <span className="admin-orders-detail__toolbar-spacer" aria-hidden />
      </div>

      <FormProvider {...form}>
        <OrderForm mode="create" onSubmit={handleSubmit} />
      </FormProvider>
    </div>
  );
};
